import { TaskStatusDto } from '@/api/generated';

export const NextTaskStatusColor: Record<
  TaskStatusDto,
  'error' | 'primary' | 'secondary' | 'success' | 'warning'
> = {
  [TaskStatusDto.Canceled]: 'warning',
  [TaskStatusDto.Done]: 'success',
  [TaskStatusDto.DoneNotConfirmed]: 'warning',
  [TaskStatusDto.InProgress]: 'secondary',
  [TaskStatusDto.New]: 'primary',
  [TaskStatusDto.Postponed]: 'warning',
  [TaskStatusDto.Rejected]: 'error',
};

export const resolveNextTaskStatus = (
  current: TaskStatusDto | undefined,
  isOwner: boolean,
): TaskStatusDto[] => {
  if (!current) {
    return [];
  }
  const nextStatuses: TaskStatusDto[] = resolveNext(current);
  if (isOwner) {
    return nextStatuses;
  }
  return nextStatuses.filter(status => status !== TaskStatusDto.Done);
};

const resolveNext = (current: TaskStatusDto): TaskStatusDto[] => {
  switch (current) {
    case 'CANCELED':
    case 'REJECTED':
      return [TaskStatusDto.New];
    case 'DONE':
      return [];
    case 'DONE_NOT_CONFIRMED':
      return [TaskStatusDto.Done, TaskStatusDto.InProgress];
    case 'IN_PROGRESS':
      return [
        TaskStatusDto.Done,
        TaskStatusDto.DoneNotConfirmed,
        TaskStatusDto.Canceled,
        TaskStatusDto.Rejected,
      ];
    case 'NEW':
      return [TaskStatusDto.InProgress, TaskStatusDto.Done, TaskStatusDto.DoneNotConfirmed];
    case 'POSTPONED':
      return [
        TaskStatusDto.InProgress,
        TaskStatusDto.Done,
        TaskStatusDto.DoneNotConfirmed,
        TaskStatusDto.Canceled,
        TaskStatusDto.Rejected,
      ];
  }
};
